import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export const ProgressBox = () => (
	<Box display="flex" justifyContent="center">
		<CircularProgress size={36} />
	</Box>
);
